<template>
    <div class="team-container" id="team">
        <div class="title" v-gsap-fade-up="{ delay: 0.1 }">{{ $t("team.title") }}</div>
        <div class="content">
            <div class="team-grid">
                <div 
                    class="team-item"
                    v-for="(item, index) in teamMembers"
                    :key="index"
                    :ref="el => setItemRef(el, index)"
                    :style="{ opacity: itemOpacities[index] || 0.1 }"
                >
                    <img
                      class="team-avatar"
                      :src="getImageSrc(item.avatar)"
                      :alt="item.name"
                      v-gsap-avatar="{ delay: index * 0.08 }"
                    />
                    <div class="team-label">{{ item.name }}</div>
                    <div class="team-position">
                      {{ $t(`team.positions.${item.positionKey}`) }}
                    </div>
                </div>
                <div class="team-divider-vertical"></div>
            </div>
        </div>
    </div>
  </template>
  
  <script>
  import RustamAvatar from '@/assets/Rustam.png';
  import VladisllavAvatar from '@/assets/Vladisllav.png';
  import SlavaAvatar from '@/assets/Slava.png';
  import ArtemAvatar from '@/assets/Artem.png';
  import DenisAvatar from '@/assets/Denis.png';
  import AlexandrAvatar from '@/assets/Alexandr.png';

  export default {
    name: "TeamBlock",
    data() {
      return {
        avatars: {
          'Rustam.png': RustamAvatar,
          'Vladisllav.png': VladisllavAvatar,
          'Slava.png': SlavaAvatar,
          'Artem.png': ArtemAvatar,
          'Denis.png': DenisAvatar,
          'Alexandr.png': AlexandrAvatar,
        },
        itemOpacities: [],
        itemRefs: [],
        teamMembers: [
          {
            name: 'Zero',
            positionKey: 'founder',
            avatar: 'Rustam.png'
          },
          {
            name: 'Aleks',
            positionKey: 'marketing',
            avatar: 'Vladisllav.png'
          },
          {
            name: 'Andrew',
            positionKey: 'product',
            avatar: 'Slava.png'
          },
          {
            name: 'mong00se',
            positionKey: 'backend',
            avatar: 'Artem.png'
          },
          {
            name: 'm1ndly',
            positionKey: 'design',
            avatar: 'Denis.png'
          },
          {
            name: 'djcrusade',
            positionKey: 'community',
            avatar: 'Alexandr.png'
          }
        ]
      };
    },
    mounted() {
      this.$nextTick(() => {
        // Инициализируем массив opacity для всех элементов
        this.itemOpacities = new Array(this.teamMembers.length).fill(0.1);
        this.handleScroll();
      });
      window.addEventListener('scroll', this.handleScroll);
      window.addEventListener('resize', this.handleScroll);
    },
    beforeUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleScroll);
    },
    methods: {
      getImageSrc(filename) {
        if (!filename) return '';
        return this.avatars[filename] || '';
      },
      setItemRef(el, index) {
        if (el) {
          this.itemRefs[index] = el;
        }
      },
      handleScroll() {
        const windowHeight = window.innerHeight;
        const centerY = windowHeight / 2;
        
        // Зона видимости - половина высоты экрана от центра
        const visibleZone = windowHeight * 0.5;
        
        this.itemRefs.forEach((itemEl, index) => {
          if (!itemEl) return;
          
          const rect = itemEl.getBoundingClientRect();
          const itemCenterY = rect.top + rect.height / 2;
          
          let opacity;
          
          // Если элемент выше центра или в центре - opacity = 1.0
          if (itemCenterY <= centerY) {
            opacity = 1.0;
          } else {
            // Если элемент ниже центра - увеличиваем opacity от 0.1 до 1.0
            // Расстояние от центра элемента до центра экрана
            const distance = itemCenterY - centerY;
            
            // Нормализуем расстояние (от 0 до 1)
            const normalizedDistance = Math.min(distance / visibleZone, 1);
            
            // Вычисляем opacity: чем ближе к центру, тем выше (от 0.1 до 1.0)
            opacity = 0.1 + (1 - normalizedDistance) * 0.9;
          }
          
          this.itemOpacities[index] = opacity;
        });
      }
    }
  };
  </script>
  
  <style scoped>
  .team-container {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 5vw;
    min-height: 100vh;
    position: relative;
  }

  .title {
    display: flex;
    justify-content: start;
    align-items: center;
    position: sticky;
    top: 128px;
    align-self: flex-start;
    font-size: clamp(24px, 3vw, 48px);
    font-weight: 300;
    text-transform: uppercase;
    white-space: nowrap;
    flex-shrink: 0;
    height: 82px;
  }

  .content {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 0;
    max-width: 60%;
  }

  .row {
    display: flex;
    align-items: center;
    width: 100%;
    height: 82px;
    white-space: nowrap;
  }

  .row p {
    margin: 0;
    font-size: clamp(22px, 2.86vw, 55px);
    font-weight: 300;
    text-transform: uppercase;
    line-height: 0.8;
    color: #fff;
    white-space: nowrap;
    flex-shrink: 0;
  }

  .graphic-smile {
    flex: 1;
    min-width: clamp(40px, 5vw, 80px);
    width: 100%;
    height: auto;
    object-fit: fill;
    margin: 0 clamp(12px, 1.5vw, 24px);
  }

  .graphic-butterfly {
    flex: 1;
    min-width: clamp(60px, 8vw, 120px);
    width: 100%;
    height: auto;
    object-fit: fill;
    margin-left: clamp(12px, 1.5vw, 24px);
  }

  .graphic-waves {
    flex: 1;
    min-width: clamp(80px, 10vw, 160px);
    width: 100%;
    height: 48px;
    object-fit: fill;
    margin-right: clamp(12px, 1.5vw, 24px);
    border-radius: 1000px;
    background: url("/src/assets/wawes.gif");
  }

  .graphic-waves-small {
    flex: 1;
    min-width: clamp(40px, 5vw, 80px);
    width: 100%;
    height: 48px;
    object-fit: fill;
    border-radius: 1000px;
    margin-left: clamp(12px, 1.5vw, 24px);
    background: url("/src/assets/wawes2.gif");
  }

  .team-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr 1fr;
    width: 100%;
    gap: clamp(16px, 2vw, 32px);
    margin-top: clamp(32px, 4vw, 64px);
    position: relative;
  }

  .team-grid::before {
    content: '';
    position: absolute;
    top: 33.33%;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(
      to right,
      #ffffff50 0%,
      #ffffff50 calc(50% - clamp(8px, 1vw, 16px)),
      transparent calc(50% - clamp(8px, 1vw, 16px)),
      transparent calc(50% + clamp(8px, 1vw, 16px)),
      #ffffff50 calc(50% + clamp(8px, 1vw, 16px)),
      #ffffff50 100%
    );
    transform: translateY(-50%);
    z-index: 1;
  }

  .team-grid::after {
    content: '';
    position: absolute;
    top: 66.66%;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(
      to right,
      #ffffff50 0%,
      #ffffff50 calc(50% - clamp(8px, 1vw, 16px)),
      transparent calc(50% - clamp(8px, 1vw, 16px)),
      transparent calc(50% + clamp(8px, 1vw, 16px)),
      #ffffff50 calc(50% + clamp(8px, 1vw, 16px)),
      #ffffff50 100%
    );
    transform: translateY(-50%);
    z-index: 1;
  }

  .team-divider-vertical {
    position: absolute;
    left: 50%;
    top: 0;
    bottom: 0;
    width: 1px;
    background: linear-gradient(
      to bottom,
      #ffffff50 0%,
      #ffffff50 calc(33.33% - clamp(8px, 1vw, 16px)),
      transparent calc(33.33% - clamp(8px, 1vw, 16px)),
      transparent calc(33.33% + clamp(8px, 1vw, 16px)),
      #ffffff50 calc(33.33% + clamp(8px, 1vw, 16px)),
      #ffffff50 calc(66.66% - clamp(8px, 1vw, 16px)),
      transparent calc(66.66% - clamp(8px, 1vw, 16px)),
      transparent calc(66.66% + clamp(8px, 1vw, 16px)),
      #ffffff50 calc(66.66% + clamp(8px, 1vw, 16px)),
      #ffffff50 100%
    );
    transform: translateX(-50%);
    z-index: 1;
    pointer-events: none;
  }

  .team-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: clamp(24px, 3vw, 48px);
    box-sizing: border-box;
    position: relative;
    z-index: 2;
    transition: opacity 0.3s ease;
  }

  .team-avatar {
    width: clamp(96px, 10vw, 192px);
    aspect-ratio: 1 / 1;
    height: auto;
    border-radius: 50%;
    object-fit: cover;
    margin-bottom: clamp(8px, 1vw, 16px);
  }

  .team-label {
    font-size: clamp(12px, 1.5vw, 18px);
    font-weight: 300;
    text-transform: uppercase;
    color: #fff;
    text-align: center;
    letter-spacing: clamp(1px, 0.2vw, 2px);
  }

  .team-position {
    font-size: clamp(8px, 1.2vw, 16px);
    font-weight: 100;
    text-transform: uppercase;
    color: #fff;
    opacity: 0.5;
    text-align: center;
    letter-spacing: clamp(1px, 0.2vw, 2px);
  }

  @media screen and (max-width: 768px) {
    .team-container {
      flex-direction: column;
      gap: 32px;
    }

    .title {
      position: static;
      text-align: center;
      width: 100%;
      display: flex;
      justify-content: center;
    }

    .content {
      max-width: 100%;
      width: 100%;
    }

    .team-grid {
      width: 100%;
    }
  }
  </style>
  